import { AfterViewInit, Component } from '@angular/core';
import { Observable } from "rxjs";
import { LogoutAction, PageItem, Ranch, SetSelectedRanchIdAction } from "common-lib";
import { PortalAppState } from "./store/reducer";
import { Store } from "@ngrx/store";
import { InitEnabledPagesAction } from "./store/user/portal-user.actions";
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
    standalone: false
})
export class MainLayoutComponent implements AfterViewInit {
  title = 'pastureProPortal';
  availableEntryPages: Observable<PageItem[]>;
  loggedInObs: Observable<boolean>;

  ranchesOfUser: Observable<Ranch[]>;
  selectedRanch: Observable<number>;
  showSideNav = false;

  constructor(
    protected store: Store<PortalAppState>,
    public dialog: MatDialog,
    protected router: Router
  ) {
    this.initializeApp();
  }

  ngAfterViewInit(): void {
    this.showSideNav = true;
  }

  private initializeApp() {
    this.loggedInObs = this.store.select(state => state.user.isLoggedIn)
    this.store.dispatch(new InitEnabledPagesAction());
    this.availableEntryPages = this.store.select(state => state.uiState.availableEntryPages);
    this.ranchesOfUser = this.store.select(state => state.ranches.ranchesOfUser);
    this.selectedRanch = this.store.select(state => state.ranches.selectedRanchId);
  }

  sideMenuToggle() {
    this.showSideNav = !this.showSideNav;
  }

  logoutUser(event) {
    this.store.dispatch(new LogoutAction());
    this.router.navigateByUrl('/login');
  }


  ranchChanged(ranchId) {
    this.store.dispatch(new SetSelectedRanchIdAction(ranchId));
  }


  getCompany() {
    if (this.router.url.includes('/prf/')) {
      return 'hargrove'
    } else if (this.router.url.includes('/advanced-prf/')) {
      return 'aap'
    }
  }
}
